// スキップリンク
import React from 'react';

interface Props {
  display_name: string;
  handleClick: () => void;
}

const SkipLink: React.FC<Props> = ({ display_name, handleClick }) => {
  return (
    <a
      className="skip-link-text btn-link skip-link-font-bold skip-link-green"
      onClick={handleClick}
    >
      {display_name}
    </a>
  );
};

export default SkipLink;
